// Contenido de las misiones guiadas (capa "Aprende") por módulo.
export const MISSIONS = {
  sistemas: {
    step: 1,
    title: 'Sistemas y proveedores',
    legalRef: 'Catastro de sistemas y encargados de tratamiento · Ley N.º 21.719',
    learn: [
      { title: 'Qué es', body: 'Es la lista de todos los lugares donde viven los datos personales de tu empresa: software (ERP, CRM, planillas), servicios en la nube, proveedores externos y también archivos en papel.' },
      { title: 'Por qué importa', body: 'Es la base de todo lo demás. Tu inventario de datos, tus evaluaciones de riesgo y tu respuesta ante una emergencia necesitan saber en qué sistemas están los datos y quién los administra.' },
      { title: 'Qué exige la ley', body: 'La Ley N.º 21.719 te hace responsable de los datos aunque los procese un proveedor. Por eso debes saber quién trata los datos por cuenta tuya y tener un contrato de tratamiento (DPA) con cada uno.' },
    ],
    examples: [
      'Software de remuneraciones donde está la información de tus trabajadores.',
      'Plataforma de email marketing con la base de clientes.',
      'Archivador físico con contratos o fichas en papel.',
    ],
    mistakes: [
      'Olvidar las planillas Excel compartidas o las carpetas en Google Drive.',
      'No registrar a proveedores pequeños (contador externo, agencia de marketing).',
      'Asumir que si el proveedor es grande, ya no hay responsabilidad de tu empresa.',
    ],
  },
  rat: {
    step: 2,
    title: 'Inventario de datos',
    legalRef: 'Registro de Actividades de Tratamiento (RAT) · Ley N.º 21.719',
    learn: [
      { title: 'Qué es', body: 'Es el inventario de las actividades donde tu empresa usa datos personales: qué datos recolectas, de quiénes, para qué, con qué justificación legal y por cuánto tiempo los guardas.' },
      { title: 'Por qué importa', body: 'Es uno de los primeros documentos que la Agencia de Protección de Datos Personales puede pedir en una fiscalización. Sin él, es muy difícil demostrar que tratas los datos de forma lícita.' },
      { title: 'Qué exige la ley', body: 'La Ley N.º 21.719 exige poder demostrar, para cada tratamiento, su finalidad, su base de licitud, las categorías de datos y titulares, los destinatarios, los plazos de conservación y las medidas de seguridad.' },
    ],
    examples: [
      'Pago de remuneraciones: datos de trabajadores, obligación legal, conservación por años.',
      'Newsletter comercial: correos de clientes, consentimiento, hasta que se den de baja.',
      'Cámaras de seguridad: imágenes de visitantes, interés legítimo, plazo corto.',
    ],
    mistakes: [
      'Registrar "bases de datos" en vez de actividades (procesos de negocio).',
      'Poner "consentimiento" como base legal para todo, aunque exista contrato u obligación legal.',
      'No definir plazos de conservación: guardar los datos "para siempre".',
    ],
  },
  dpia: {
    step: 3,
    title: 'Evaluación de riesgos',
    legalRef: 'Evaluación de Impacto en Protección de Datos (DPIA) · art. 15 bis, Ley N.º 21.719',
    learn: [
      { title: 'Qué es', body: 'Es un análisis previo de los riesgos que un tratamiento de datos puede generar para las personas, y de las medidas que tomarás para reducirlos.' },
      { title: 'Por qué importa', body: 'Las actividades de alto riesgo (datos sensibles, menores, monitoreo masivo, decisiones automatizadas) son las que más expuestas quedan ante reclamos y fiscalizaciones.' },
      { title: 'Qué exige la ley', body: 'La Ley N.º 21.719 exige realizar una evaluación de impacto antes de iniciar tratamientos que puedan implicar un alto riesgo para los derechos de las personas. Priviax detecta esas actividades desde tu inventario.' },
    ],
    examples: [
      'Control de acceso con huella o reconocimiento facial.',
      'Ficha clínica o datos de salud de pacientes o trabajadores.',
      'Evaluación crediticia automatizada de clientes.',
    ],
    mistakes: [
      'Hacer la evaluación después de lanzar el proyecto, cuando ya es tarde para cambiar el diseño.',
      'Identificar riesgos pero no definir medidas concretas ni responsables.',
      'No revisar la evaluación cuando cambia el tratamiento o el proveedor.',
    ],
  },
  documentos: {
    step: 4,
    title: 'Documentos legales',
    legalRef: 'Deber de información y transparencia · Ley N.º 21.719',
    learn: [
      { title: 'Qué es', body: 'Son los documentos que explican a las personas cómo usas sus datos (política de privacidad, aviso de cookies, cláusulas de consentimiento) y los contratos con tus proveedores (DPA).' },
      { title: 'Por qué importa', body: 'Son lo primero que ven tus clientes, trabajadores y la autoridad. Un documento genérico o copiado que no refleja lo que realmente haces es un riesgo, no una protección.' },
      { title: 'Qué exige la ley', body: 'La Ley N.º 21.719 exige informar a los titulares, de forma clara y accesible, quién trata sus datos, para qué, con qué base legal, a quién se comunican y cómo ejercer sus derechos.' },
    ],
    examples: [
      'Política de privacidad publicada en el sitio web.',
      'Cláusula de consentimiento en el formulario de contacto o de compra.',
      'Contrato de tratamiento (DPA) firmado con tu proveedor de remuneraciones.',
    ],
    mistakes: [
      'Copiar la política de privacidad de otra empresa.',
      'Aprobar el documento pero nunca publicarlo en el sitio o entregarlo a los trabajadores.',
      'No actualizar los documentos cuando cambian tus actividades o proveedores.',
    ],
  },
  cookies: {
    step: 5,
    title: 'Banner de cookies',
    legalRef: 'Consentimiento para cookies y tecnologías de seguimiento · Ley N.º 21.719',
    learn: [
      { title: 'Qué es', body: 'Es el aviso que aparece en tu sitio web para que cada visitante elija qué cookies acepta (analíticas, publicitarias, funcionales), además de las estrictamente necesarias.' },
      { title: 'Por qué importa', body: 'Las cookies de analítica y publicidad recogen datos personales de navegación. Sin un consentimiento válido y registrado, no puedes demostrar que el visitante aceptó.' },
      { title: 'Qué exige la ley', body: 'Cuando el tratamiento se basa en el consentimiento, la Ley N.º 21.719 exige que sea libre, informado, específico e inequívoco, y que puedas demostrar que lo obtuviste. Retirarlo debe ser tan fácil como darlo.' },
    ],
    examples: [
      'Google Analytics o Meta Pixel instalados en tu sitio.',
      'Chat de soporte que guarda el historial del visitante.',
      'Remarketing publicitario a quienes visitaron tu tienda online.',
    ],
    mistakes: [
      'Cargar cookies de analítica antes de que el visitante acepte.',
      'Banner con solo el botón "Aceptar", sin opción real de rechazar.',
      'No guardar evidencia de cada consentimiento (fecha, versión, elección).',
    ],
  },
  arco: {
    step: 6,
    title: 'Solicitudes de titulares',
    legalRef: 'Derechos ARCO+ (acceso, rectificación, supresión, oposición, portabilidad y bloqueo) · Ley N.º 21.719',
    learn: [
      { title: 'Qué es', body: 'Son las solicitudes que una persona hace para saber qué datos tienes de ella, corregirlos, eliminarlos, oponerse a su uso, llevárselos a otra empresa o bloquearlos temporalmente.' },
      { title: 'Por qué importa', body: 'No responder o responder fuera de plazo es una de las causas más comunes de reclamos ante la autoridad. Un canal claro y ordenado evita que una solicitud se pierda en un correo.' },
      { title: 'Qué exige la ley', body: 'La Ley N.º 21.719 exige ofrecer un canal para ejercer estos derechos, verificar la identidad del solicitante y responder dentro del plazo legal. Priviax controla el plazo de cada solicitud por ti.' },
    ],
    examples: [
      'Un excliente pide que borres sus datos de tu base de marketing.',
      'Un trabajador pide copia de toda la información que la empresa tiene de él.',
      'Un cliente pide corregir su dirección o su RUT mal ingresado.',
    ],
    mistakes: [
      'Recibir solicitudes por cualquier canal sin registrar cuándo llegaron.',
      'Entregar datos sin verificar la identidad de quien los pide.',
      'Borrar datos que la ley obliga a conservar (por ejemplo, tributarios) sin explicarlo al titular.',
    ],
  },
  brechas: {
    step: 7,
    title: 'Emergencias 72h',
    legalRef: 'Gestión y notificación de brechas de seguridad · Ley N.º 21.719',
    learn: [
      { title: 'Qué es', body: 'Una brecha es cualquier incidente que exponga datos personales: un correo mal enviado, un pendrive extraviado, un acceso no autorizado o un hackeo.' },
      { title: 'Por qué importa', body: 'Desde que te enteras, corre un plazo corto para notificar a la Agencia de Protección de Datos Personales. Si el riesgo para las personas es alto, también debes avisarles.' },
      { title: 'Qué exige la ley', body: 'La Ley N.º 21.719 exige contener el incidente, notificar a la Agencia sin dilaciones indebidas, comunicar a los titulares cuando corresponda y documentar cada paso. Priviax organiza el proceso con un plazo de 72 horas.' },
    ],
    examples: [
      'Planilla con datos de clientes enviada por error a un destinatario externo.',
      'Notebook robado con información de trabajadores sin cifrar.',
      'Ransomware que bloquea o exfiltra la base de datos de clientes.',
    ],
    mistakes: [
      'Esperar a "tener toda la información" antes de registrar el incidente.',
      'No dejar registro de las medidas de contención y de quién las tomó.',
      'Pensar que un incidente pequeño no cuenta como brecha.',
    ],
  },
  trazabilidad: {
    title: 'Bitácora de acciones',
    legalRef: 'Trazabilidad y responsabilidad proactiva · Ley N.º 21.719',
    learn: [
      { title: 'Qué es', body: 'Es el registro de quién hizo qué y cuándo con los datos personales: lo que se hace dentro de Priviax, los eventos que registras a mano y los que importas desde otros sistemas.' },
      { title: 'Por qué importa', body: 'Ante un reclamo o una brecha, la bitácora permite reconstruir qué pasó. Sin registro, es tu palabra contra la del reclamante.' },
      { title: 'Qué exige la ley', body: 'La Ley N.º 21.719 adopta el principio de responsabilidad: no basta con cumplir, hay que poder demostrarlo. La trazabilidad es parte de esa evidencia.' },
    ],
    examples: [
      'Exportación de un listado de clientes a un proveedor.',
      'Destrucción de expedientes físicos al cumplir su plazo.',
      'Atención de una solicitud de acceso de un titular.',
    ],
    mistakes: [
      'Registrar solo lo que pasa en el sistema y olvidar los procesos en papel.',
      'Dejar los registros de otros sistemas sin importar ni revisar.',
      'No registrar las acciones excepcionales (exportaciones masivas, accesos de soporte).',
    ],
  },
  fiscalizacion: {
    title: 'Carpeta de evidencias',
    legalRef: 'Preparación ante fiscalizaciones de la Agencia de Protección de Datos Personales',
    learn: [
      { title: 'Qué es', body: 'Es un paquete descargable que reúne la evidencia de cumplimiento de tu empresa: inventario, documentos, evaluaciones, solicitudes, brechas y bitácora.' },
      { title: 'Por qué importa', body: 'Si la Agencia te fiscaliza, tendrás plazos acotados para responder. Tener la evidencia ordenada en un solo lugar evita semanas de búsqueda.' },
      { title: 'Qué exige la ley', body: 'La Ley N.º 21.719 exige poder demostrar el cumplimiento. Cada carpeta generada queda registrada con su fecha, autor y huella digital (hash) para acreditar su integridad.' },
    ],
    examples: [
      'Respuesta a un requerimiento de información de la Agencia.',
      'Revisión anual del directorio o del comité de riesgos.',
      'Due diligence de un cliente corporativo o inversionista.',
    ],
    mistakes: [
      'Generar la carpeta solo cuando llega la fiscalización.',
      'Tener módulos vacíos: la carpeta solo refleja lo que registraste.',
      'No guardar las versiones anteriores generadas.',
    ],
  },
};
